import { Download } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import API from "../../../../services/API";

const UNITS = [1, 2, 3];

export default function SynthesisModal({ sessionId, open, onClose, fileName }) {

    const [showFilter, setShowFilter] = useState(false);
    const [selectedUnits, setSelectedUnits] = useState([...UNITS]);
    const [loading, setLoading] = useState(null);

    useEffect(() => {
        if (open) {
            setShowFilter(false);
            setSelectedUnits([...UNITS]);
        }
    }, [open, sessionId]);

    const getFileName = () => fileName || `Synthese-${sessionId}.pdf`;

    const download = (endpoint, type) => {
        setLoading(type);

        API.download(endpoint, getFileName())
            .catch(e => console.log(e))
            .finally(() => setLoading(null));
    };

    const handleDownloadFull = () => {
        download(`/dpc/sessions/${sessionId}/synthesis.pdf`, "full");
    };

    const handleDownloadFiltered = () => {
        const units = [...selectedUnits].sort((a, b) => a - b).join(",");
        download(`/dpc/sessions/${sessionId}/synthesis.pdf?units=${units}`, "filtered");
    };

    const handleUnitToggle = (unit) => (_, checked) => {
        setSelectedUnits(prev =>
            checked ? [...prev, unit] : prev.filter(u => u !== unit)
        );
    };

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>Synthèse</DialogTitle>

            <DialogContent>
                <Stack spacing={2} sx={{ minWidth: 300, pt: 1 }}>
                    <LoadingButton
                        variant="contained"
                        startIcon={<Download />}
                        loading={loading === "full"}
                        onClick={handleDownloadFull}
                    >
                        Télécharger la synthèse complète
                    </LoadingButton>

                    <Button
                        variant="outlined"
                        onClick={() => setShowFilter(v => !v)}
                    >
                        Filtrer les unités
                    </Button>

                    {showFilter && (
                        <Stack spacing={0.5}>
                            {UNITS.map(unit => (
                                <Stack
                                    key={unit}
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Checkbox
                                        checked={selectedUnits.includes(unit)}
                                        onChange={handleUnitToggle(unit)}
                                        sx={{ p: 0.5 }}
                                    />
                                    <Typography variant="body2">
                                        {`Unité ${unit}`}
                                    </Typography>
                                </Stack>
                            ))}

                            <LoadingButton
                                variant="contained"
                                startIcon={<Download />}
                                loading={loading === "filtered"}
                                onClick={handleDownloadFiltered}
                                disabled={selectedUnits.length === 0}
                            >
                                Télécharger
                            </LoadingButton>
                        </Stack>
                    )}
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Fermer</Button>
            </DialogActions>
        </Dialog>
    );
}
